import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ColumnsManagerComponent} from './columns-manager.component';
import {L10nModule} from '../translate';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        L10nModule
    ],
    declarations: [
        ColumnsManagerComponent
    ],
    exports: [
        ColumnsManagerComponent
    ]
})
export class ColumnsManagerModule {}
